import { Card, Typography } from 'antd';
import { IAgent } from 'interfaces/agents';
import { PageHeader } from 'components/professor_area/PageHeader';
import { SettingOutlined } from '@ant-design/icons';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { useShow } from '@refinedev/core';

const { Title, Text } = Typography;

export const AgentShow = () => {
  const { queryResult } = useShow<IAgent>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout isLoading={isLoading} title="Visualizar usuário">
      <PageHeader title="Visualizar usuário" icon={SettingOutlined} />
      <Card>
        <Title level={5}>ID</Title>
        <Text>{record?.id}</Text>
        <Title level={5}>Nome</Title>
        <Text>{record?.name}</Text>
        <Title level={5}>Login</Title>
        <Text>{record?.login}</Text>
      </Card>
    </ShowLayout>
  );
};
